import { Buffer } from "buffer";
var Type;
(function (Type) {
    Type[Type["Boolean"] = 0] = "Boolean";
    Type[Type["Number"] = 1] = "Number";
    Type[Type["BigInt"] = 2] = "BigInt";
    Type[Type["String"] = 3] = "String";
    Type[Type["Uint8Array"] = 4] = "Uint8Array";
    Type[Type["Object"] = 5] = "Object";
    Type[Type["Array"] = 6] = "Array";
    Type[Type["Undefined"] = 7] = "Undefined";
    Type[Type["Null"] = 8] = "Null";
})(Type || (Type = {}));
function concat(list) {
    const total = list.reduce((size, a) => size + a.length, 0);
    const arr = new Uint8Array(total);
    let offset = 0;
    list.forEach((a) => {
        arr.set(a, offset);
        offset += a.length;
    });
    return arr;
}
class Decoder {
    constructor(data) {
        this.data = data;
        this.offset = 0;
    }
    read(n) {
        const start = this.offset;
        this.offset += n;
        if (this.offset > this.data.length)
            throw Error("read overflow");
        return this.data.subarray(start, this.offset);
    }
    decodeBigInt() {
        return BigInt(this.decodeString());
    }
    decodeNumber() {
        return Number(this.decodeString());
    }
    decodeUint8Array() {
        const length = Buffer.from(this.read(4)).readUInt32LE(0);
        return this.read(length);
    }
    decodeBoolean() {
        return Boolean(this.read(1)[0]);
    }
    decodeString() {
        const de = this.decodeUint8Array();
        return Buffer.from(de).toString();
    }
    decodeArray() {
        const length = this.decode(); // decodeNumber
        return Array(length).fill(0).map(() => this.decode());
    }
    decodeObject() {
        const length = this.decode(); // decodeNumber
        const entries = Array(length).fill(0).map(() => [this.decode(), this.decode()]);
        return Object.fromEntries(entries);
    }
    decode() {
        const type = this.read(1)[0];
        switch (type) {
            case Type.BigInt:
                return this.decodeBigInt();
            case Type.Number:
                return this.decodeNumber();
            case Type.Boolean:
                return this.decodeBoolean();
            case Type.String:
                return this.decodeString();
            case Type.Uint8Array:
                return this.decodeUint8Array();
            case Type.Array:
                return this.decodeArray();
            case Type.Object:
                return this.decodeObject();
            case Type.Undefined:
                return undefined;
            case Type.Null:
                return null;
        }
        throw `unkonw type: ${type}`;
    }
}
function encodeUint8Array(data) {
    const en = new Uint8Array(data.length + 5);
    en[0] = Type.Uint8Array;
    const lenBuffer = Buffer.alloc(4);
    lenBuffer.writeUInt32LE(data.length);
    en.set(lenBuffer, 1);
    en.set(data, 5);
    return en;
}
function encodeUndefined() {
    return Uint8Array.from([Type.Undefined]);
}
function encodeNull() {
    return Uint8Array.from([Type.Null]);
}
function encodeBigInt(data) {
    const en = encodeString(data.toString());
    en[0] = Type.BigInt;
    return en;
}
function encodeNumber(data) {
    const en = encodeString(data.toString());
    en[0] = Type.Number;
    return en;
}
function encodeBoolean(data) {
    return new Uint8Array([Type.Boolean, Number(data)]);
}
function encodeString(data) {
    const en = encodeUint8Array(Buffer.from(data));
    en[0] = Type.String;
    return en;
}
function encodeObject(data) {
    const entries = Object.entries(data);
    const ens = entries.map(([key, value]) => {
        const keyBuf = encode(key);
        const valueBuf = encode(value);
        return concat([keyBuf, valueBuf]);
    });
    return concat([Uint8Array.from([Type.Object]), encode(entries.length), ...ens]);
}
function encodeArray(data) {
    const ens = data.map(elem => encode(elem));
    return concat([Uint8Array.from([Type.Array]), encode(ens.length), ...ens]);
}
export function encode(data) {
    if (data instanceof Uint8Array) {
        return encodeUint8Array(data);
    }
    if (data instanceof Array) {
        return encodeArray(data);
    }
    if (data instanceof Object) {
        return encodeObject(data);
    }
    if (data === null) {
        return encodeNull();
    }
    switch (typeof data) {
        case 'string':
            return encodeString(data);
        case 'number':
            return encodeNumber(data);
        case 'bigint':
            return encodeBigInt(data);
        case 'boolean':
            return encodeBoolean(data);
        case 'undefined':
            return encodeUndefined();
    }
    throw `unsuport type: ${data}`;
}
export function decode(data) {
    const decoder = new Decoder(data);
    return decoder.decode();
}
export function encodeToStr(data) {
    return Buffer.from(encode(data)).toString('hex');
}
export function decodeFromStr(data) {
    return decode(Uint8Array.from(Buffer.from(data, 'hex')));
}
//# sourceMappingURL=coder.js.map